import styled, { css } from 'styled-components';

export const PanelWrapper = styled.section`
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

export const HubHeaderSection = styled.section`
  padding: 0 20px;
  position: sticky;
  background: ${({ theme }) => theme.colors.standardComponentBackground};
  top: 60px;
  z-index: 3;
  margin-bottom: 26px;

  textarea {
    color: ${({ theme }) => theme.colors.white};
  }

  @media ${({ theme }) => theme.sizes.tablet} {
    padding: 0px 42px;
  }
`;

export const ContentEditorSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderText = styled.textarea`
  color: ${({ theme }) => theme.colors.black_9};
  background-color: ${({ theme }) => theme.colors.transparent};
  font-size: 36px;
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  resize: none;
  width: 100%;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey};
    font-style: italic;
    text-indent: -4px;
  }
`;

export const ContentSection = styled.section`
  margin: 0;
  color: ${({ theme }) => theme.colors.black_9};
  font-size: 14px;
  padding: 0 20px;

  @media ${({ theme }) => theme.sizes.tablet} {
    padding: 0px 42px;
  }
`;

export const LoopFooterSection = styled.section`
  margin-top: auto;
  border-top: 1px solid ${({ theme }) => theme.colors.white_2};
  position: sticky;
  background: ${({ theme }) => theme.colors.standardComponentBackground};
  z-index: 2;
  bottom: 0;
`;

export const BottomPanel = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  height: 60px;
  min-height: 60px;
  margin-top: auto;
  padding: 0 30px;
  justify-content: ${({ align }) => (align ? align : 'space-between')};

  .save-button {
    color: ${({ theme }) => theme.colors.white};
    transition:
      color 0.2s ease,
      background-color 0.2s ease;
    margin-left: 20px;

    &:hover,
    &:focus {
      color: ${({ theme }) => theme.colors.black};
      background-color: ${({ theme }) => theme.colors.buttonGreenFront};
      transition:
        color 0.2s ease,
        background-color 0.2s ease;
    }
  }

  .add-question-button,
  .add-term-button {
    transition: border-color 0.2s ease;

    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.colors.black};
      transition: border-color 0.2s ease;
    }
  }
`;

export const FieldSet = styled.fieldset`
  border: 1px solid ${({ theme }) => theme.colors.white_2};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.white_7};
  margin-bottom: 40px;
  padding: 25px;
  width: 100%;

  *:last-of-type {
    margin-bottom: 0px;
  }
`;

export const FieldSetLabel = styled.legend`
  all: unset;
  padding: 0 10px;
`;

const IconButton = styled.button`
  position: relative;
  border: none;
  background-color: ${({ theme }) => theme.colors.standardComponentBackground};
  outline: none;
  margin: 0px 0px 0px 15px;
  padding: 0px 0px 0px 20px;
  color: ${({ theme }) => theme.colors.white};
  transition: color 0.2s ease;
  opacity: 0.8;
  transition: opacity 0.2s ease;

  &:after {
    width: 15px;
    height: 100%;
    min-height: 20px;
    position: absolute;
    opacity: 0.8;
    left: 0;
    top: 0px;
    content: ' ';
    background-repeat: no-repeat;
    background-position: center left;
    transition: opacity 0.2s ease;

    ${({ src }) =>
      src &&
      css`
        background-image: url(${src});
      `}
  }

  &:hover:not([disabled]),
  &:focus:not([disabled]) {
    opacity: 1;
    transition: opacity 0.2s ease;
    &:after {
      opacity: 1;
      transition: opacity 0.2s ease;
    }
  }
`;

export const DeleteButton = styled(IconButton)`
  margin-left: 0;
  ${FieldSet} & {
    margin-bottom: 18px !important;
  }

  &:after {
    min-height: 20px;
  }
`;

export const AnnounceButton = styled(IconButton)``;

export const LockButton = styled(IconButton)``;

export const CopyButton = styled(IconButton)``;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LoopTopSection = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.standardComponentBackground};
  justify-content: flex-end;
  padding: 20px;
  padding-top: 22px;
  position: sticky;
  top: 0;
  z-index: 3;

  @media ${({ theme }) => theme.sizes.tablet} {
    padding: 20px 30px;
    padding-top: 22px;
  }
`;

export const ClosePanelIcon = styled.button`
  opacity: 0.6;
  transition: 0.2s opacity ease;
  background-repeat: no-repeat;
  background-color: ${({ theme }) => theme.colors.transparent};
  display: block;
  cursor: pointer;
  background-size: 18px 18px;
  height: 18px;
  width: 18px;
  margin: 0 0 0 25px;
  border: none;
  outline: none;

  &:hover,
  &:focus {
    opacity: 1;
    transition: 0.2s opacity ease;
  }

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}
`;

export const EditorWrapper = styled.div`
  display: flex;
  margin-bottom: 30px;
`;

export const ImageUploadWrapper = styled.div`
  display: flex;
  margin-bottom: 30px;
`;

export const ImageWrapper = styled.div`
  display: flex;
`;

export const LoopImage = styled.img`
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  cursor: pointer;
  height: 36px;
  width: 36px;
  margin-left: 20px;
  transform: scale(1);
  transition: transform 0.2s ease;

  &:hover,
  &:focus {
    transform: scale(1.2);
    transition: transform 0.2s ease;
  }
`;

export const Duration = styled.div`
  display: flex;
  align-items: center;

  input {
    border: none;
  }
`;

export const DurationUnit = styled.span`
  display: flex;
  color: ${({ theme }) => theme.colors.white_9};
  margin-left: 7px;
  margin-right: auto;
`;

export const LinkButton = styled.button`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.transparent};
  background-repeat: no-repeat;
  background-position: center left;
  padding: 0px 0px 0px 33px;
  cursor: pointer;
  border: none;
  outline: none;
  opacity: 0.8;
  transition: opacity 0.2s ease;
  margin-bottom: 18px;
  white-space: nowrap;

  &:hover,
  &:focus {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  &.share-link {
    background-image: url('/assets/images/tmp/v2/icons/shareIcon.png');
    color: ${({ theme }) => theme.colors.behaviorGreenFront};
    background-position: 3px;
  }

  &.library-publish {
    background-image: url('/assets/images/theme-2/icons/library-white.svg');
    background-size: 20px;
  }

  &.curriculum-link {
    background-image: url('/assets/images/tmp/v2/curriculum.png');
    background-position: 2px center;
  }

  &.add-collaborator {
    background-image: url('/assets/images/theme-2/icons/collaborator.svg');
  }

  &.copy-circle {
    background-image: url('/assets/images/theme-2/icons/copy.svg');
    background-size: 15px 10px;
    background-position: 3px center;
  }

  &.reorder-hubs {
    background-image: url('/assets/images/icons/reorder.svg');
    background-size: 26px;
    background-position: -3px -4px;
  }
`;

export const List = styled.ul`
  display: flex;
  list-style-type: none;
  margin: 0px 0px 17px 0px;
  padding: 0px;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.white_7};
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const UserImage = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 12px;
`;

export const UserName = styled.span`
  font-size: 14px;
`;

export const ReviewPanel = styled.div`
  padding-bottom: 18px;
`;

export const ReviewForm = styled.form`
  display: flex;
`;

export const ReviewButton = styled.button`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.standardBlackBackground};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 18px;
  border: 2px solid ${({ theme }) => theme.colors.iconButtonBorder};
  padding: 9px 18px;
  height: 36px;
  margin-right: 10px;
  transition: border-color 0.2s ease-in-out;

  &:hover,
  &:focus {
    transition: border-color 0.2s ease-in-out;
    border-color: ${({ theme }) => theme.colors.iconButtonBorderHover};
  }
`;

export const Categories = styled.div``;

export const Category = styled.button`
  background-color: ${({ theme }) => theme.colors.transparent};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  margin: 0;
  padding: 0;
  font-size: 15px;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover,
  &:focus {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  &.grade-1-3 {
    opacity: 1;
    color: ${({ theme }) => theme.colors.behaviorPinkFront};
  }

  &.grade-4-6 {
    opacity: 1;
    color: ${({ theme }) => theme.colors.behaviorBlueFront};
  }

  &.grade-7-9 {
    opacity: 1;
    color: ${({ theme }) => theme.colors.behaviorGreenFront};
  }

  &.grade-teacher {
    opacity: 1;
    color: ${({ theme }) => theme.colors.behaviorPurpleFront};
  }
`;
